<script setup>
import VideoPlayer from '../../VideoPlayer.vue'

const props = defineProps({
  item: Object,
})

const backgroundVideo = computed(() => props.item.properties?.backgroundVideo || null)
const amount = computed(() => props.item.enrichment?.amount?.toLocaleString('nl-NL'))
</script>

<template>
  <div
    :style="{
      left: item.properties.position.xCenter + 'px',
      top: item.properties.position.yTop + 'px',
      fontSize: item.properties.position.fontSize + 'px',
      color: item.properties.position.textColor,
    }"
    class="absolute -translate-x-1/2 font-geomanist text-white font-medium leading-none text-center"
    v-text="`€${amount}`"
  />
  <VideoPlayer :src="backgroundVideo" autoplay muted loop class="size-full object-cover" />
</template>
